<template>
  <v-container :class="'test-overview-card ' + (publicView ? 'public-view' : '')" fluid>
    <v-row v-if="!publicView" class="d-flex header-controls">
      <p class="header__text" @click="$router.go(-1)"><i class="fa-regular fa-chevron-left"></i>{{ $t('btnBackToTest') }}
      </p>
      <ShareLinkButton />
    </v-row>
    <!-- Funding Test Overview  !-->
    <v-row align="center" justify="center" class="mobile-only">
      <v-card class="cardContainer" outlined>
        <v-row class="d-flex justify-space-between responsive-row">
          <v-col class="col-cardContainer">
            <div class="d-flex calendar-div">
              <v-icon class="" small>fa-regular fa-calendar-day</v-icon>
              <p class="my-0" v-html="$tc('activityDays', this.totalDays, {
                days: this.totalDays,
                from: formatDate(
                  new Date($store.state.fundingTest.createdAt)
                ),
              })
                " />
            </div>
            <div class="d-flex wallet-div">
              <v-icon class="" small>fa-regular fa-wallet</v-icon>
              <p class="my-0" v-html="$t('brokerAccount_TestOverview', {
                broker: $store.state.fundingTest.account.brokerName,
                identifier: $store.state.fundingTest.account.identifier,
              })
                " />
            </div>
          </v-col>
          <v-col class="d-flex align-center justify-end p-0 m-0 custom-img second-col responsive-col" cols="auto">
            <div class="d-flex flex-column align-items-start logoContainer responsive-div">
              <v-img :src="$store.state.fundingTest.evaluation.vendorLogoUrl" max-height="37px" max-width="150px"
                position="center" m contain />
              <p v-if="market !== undefined" class="market-paragraph">
                {{ $t(`summary.market.${market}`) }}
              </p>
            </div>
            <v-divider vertical class="ml-4 mr-4"></v-divider>
            <div class="d-flex flex-column ml-4 mr-4 rightInfo">
              <h2><strong>{{ formatThousands($store.state.fundingTest.evaluation.initialBalance) }}</strong></h2>
              <p>Step {{ $store.state.fundingTest.step }}</p>
            </div>
          </v-col>
        </v-row>
        <v-overlay :absolute="true" :value="overlayLoadingDetails">
          <v-progress-circular color="primary" :size="70" width="5" indeterminate />
        </v-overlay>
        <v-container class="cardContainer-container" fluid>
          <div class="cards-parent-container" @scroll="(e) => updateSliderControlsStatus(e.target)">
            <v-row class="custom-row-card">
              <!-- Primera tarjeta -->
              <v-tooltip top left class="custom-tooltip" v-if="stringDataBalance">
                <template v-slot:activator="{ on, attrs }">
                  <v-card class="card-custom " v-bind="attrs" v-on="on">
                    <v-card-text>
                      <div class="text-pair">
                        <img src="@/assets/icons/EllipseCalmGreen.svg" alt="Icon" class="icon" />
                        <p class="custom-paragraph">
                          {{ stringDataBalance.firstTitle }}:
                        </p>
                        <h2 class="custom-h2">
                          ${{ stringDataBalance.firstNumber }}
                        </h2>
                      </div>
                      <div class="text-pair">
                        <img src="@/assets/icons/EllipseNewGreen.svg" alt="Icon" class="icon" />
                        <p class="custom-paragraph">
                          {{ stringDataBalance.secondTitle }}:
                        </p>
                        <h2 class="custom-h2">
                          ${{ stringDataBalance.secondNumber }}
                        </h2>
                      </div>
                      <v-progress-linear v-if="seriesBalance.length > 0" :height="14" :color="'var(--v-mainGreen-base)'"
                        :background-color="'#C3FFE3'" :value="seriesBalance[0]" class="custom-progress" />
                    </v-card-text>
                  </v-card>
                </template>
                <div class="tooltip">
                  <span class="tooltiptext">
                    {{ stringDataBalance.reachedProfit }}%
                  </span>
                </div>
              </v-tooltip>

              <!-- Segunda tarjeta -->
              <v-tooltip top left class="custom-tooltip" v-if="stringDataDrawdownLoss">
                <template v-slot:activator="{ on, attrs }">
                  <v-card class="card-custom" v-bind="attrs" v-on="on">
                    <v-card-text>
                      <div class="text-pair">
                        <img src="@/assets/icons/EllipseGrey.svg" alt="Icon" class="icon" />
                        <p class="custom-paragraph">
                          {{ stringDataDrawdownLoss.firstTitle }}:
                        </p>
                        <h2 class="custom-h2">
                          ${{ stringDataDrawdownLoss.firstNumber }}
                        </h2>
                      </div>
                      <div class="text-pair">
                        <img src="@/assets/icons/EllipseRed.svg" alt="Icon" class="icon" />
                        <p class="custom-paragraph">
                          {{ stringDataDrawdownLoss.secondTitle }}:
                        </p>
                        <h2 class="custom-h2">
                          ${{ stringDataDrawdownLoss.secondNumber }}
                        </h2>
                      </div>
                      <v-progress-linear v-if="seriesDrawdownLoss.length > 0" :height="14" :color="'#C42A14'"
                        background-color="var(--v-progressBarBackground-base)" :value="seriesDrawdownLoss[0]"
                        class="custom-progress" />
                    </v-card-text>
                  </v-card>
                </template>
                <div class="tooltip">
                  <span class="tooltiptext">
                    {{ stringDataDrawdownLoss.reachedDrawdownLoss }}%
                  </span>
                </div>
              </v-tooltip>

              <!-- Tercera tarjeta -->
              <v-tooltip top left class="custom-tooltip" v-if="stringDataDailyLoss">
                <template v-slot:activator="{ on, attrs }">
                  <v-card v-if="stringDataDailyLoss" class="card-custom" v-bind="attrs" v-on="on">
                    <v-card-text>
                      <div class="text-pair">
                        <img src="@/assets/icons/EllipseGrey.svg" alt="Icon" class="icon" />
                        <p class="custom-paragraph">
                          {{ stringDataDailyLoss.firstTitle }}:
                        </p>
                        <h2 class="custom-h2">
                          ${{ stringDataDailyLoss.firstNumber }}
                        </h2>
                      </div>
                      <div class="text-pair">
                        <img src="@/assets/icons/EllipseRed.svg" alt="Icon" class="icon" />
                        <p class="custom-paragraph">
                          {{ stringDataDailyLoss.secondTitle }}:
                        </p>
                        <h2 class="custom-h2">
                          ${{ stringDataDailyLoss.secondNumber }}
                        </h2>
                      </div>
                      <v-progress-linear v-if="seriesDailyLoss.length > 0" :height="14" :color="'#C42A14'"
                        background-color="var(--v-progressBarBackground-base)" :value="seriesDailyLoss[0]"
                        class="custom-progress" />
                    </v-card-text>
                  </v-card>
                </template>
                <div v-if="stringDataDailyLoss" class="tooltip">
                  <span class="tooltiptext">
                    {{ stringDataDailyLoss.reachedDailyLoss }}%
                  </span>
                </div>
              </v-tooltip>
            </v-row>
            <!-- Botones de navegación para dispositivos móviles -->
          </div>
          <div class="slider-controls">
            <button @click="scrollContainer(false)" class="prev-btn">
              <i class="fa-regular fa-chevron-left"></i>
            </button>
            <button @click="scrollContainer(true)" class="next-btn">
              <i class="fa-regular fa-chevron-right"></i>
            </button>
          </div>
          <RulesOverview class="rules-overview-outer" :collapsed="false" />
          <v-row class="actions">
            <!-- Botones de navegación para la version privada -->
            <AbandonButton v-if="!publicView" @confirmAbandon="confirmAbandon" class="ml-auto" />
            <!--botones de version publica-->
            <div v-if="publicView" class="buttons-container">
              <!-- NewPoweredBy a la izquierda -->
              <NewPoweredBy />
              <!-- Botón de registro y enlace de inicio de sesión a la derecha -->
              <div class="create-account-container">
                <button class="button-get-challenged" @click="$router.push('/register')">
                  <v-icon class="icon-Restart">fa-regular fa-arrow-up-right-from-square</v-icon>
                  {{ $t("btnCreateAcc") }}
                </button>
                <p class="login-paragraph">
                  {{ $t("alreadyHasAcc") }}
                  <a href="https://app.swiset.com/" target="_blank" class="login-link">
                    {{ $t("login_TestOverview") }}
                  </a>
                </p>
              </div>
            </div>
          </v-row>
        </v-container>
      </v-card>
    </v-row>

    <!-- Overlay confirm abandon!-->
    <v-overlay :dark="false" v-model="overlayAbandon">
      <AbandonTest @close="overlayAbandon = false" />
    </v-overlay>
  </v-container>
</template>

<script>
import Repository from "../../../../repositories/funding";
import { mapMutations } from "vuex";
import RulesOverview from "@/views/Funding/Simulation/components/RulesOverview";
import AbandonButton from "@/views/Funding/Simulation/components/AbandonButton";
import AbandonTest from "@/views/Funding/Simulation/components/AbandonTest";
import ShareLinkButton from "@/views/Funding/Simulation/components/ShareLinkButton.vue";
import NewPoweredBy from '../../../../components/NewPoweredBy.vue';

export default {
  name: "TestOverview",
  components: {
    AbandonTest,
    AbandonButton,
    RulesOverview,
    ShareLinkButton,
    NewPoweredBy
  },
  props: {
    testId: Number,
    market: String,
  },
  data() {
    return {
      overlayLoadingDetails: false,
      overlayAbandon: false,

      // Days Data
      months: [],
      totalDays: 0,
      activeDays: 0,
      remainingDays: 0,
      cycles: 1,

      // Main Stats
      stringDataBalance: {
        firstTitle: "",
        firstNumber: 0,
        secondTitle: "",
        secondNumber: 0,
      },
      stringDataDailyLoss: null,
      stringDataDrawdownLoss: null,
      seriesBalance: [0],
      seriesDailyLoss: [0],
      seriesDrawdownLoss: [0],
      maxCard: 2,
      isMobile: false,
      //
      publicView: false,
    };
  },
  async mounted() {
    await this.init();
    if (window.innerWidth <= 768) {
      this.updateSliderControlsStatus(document.querySelector('.test-overview-card .cards-parent-container'));
    }
  },
  methods: {
    ...mapMutations(["setFundingTest"]),
    async init() {
      this.getMonths();
      this.overlayLoadingDetails = true;
      if (
        this.$route.query.id !== undefined &&
        this.$route.query.identifier !== null
      ) {
        // Vista pública
        let testId = this.$route.query.id;
        let brokerId = this.$route.query.identifier;
        this.publicView = true;
        await Repository.fundingTestOverviewPublic(testId, brokerId).then(
          async (response) => {
            if (response.status < 400) {
              this.overlayLoadingDetails = false;
              let fundingTest = response.data[0];
              let newFundingTest = {
                id: fundingTest.id,
                createdAt: fundingTest.fundingChallengeTest.createdAt,
                finishedAt: fundingTest.fundingChallengeTest.finishedAt,
                currentCycleStartTime:
                  fundingTest.fundingChallengeTest.currentCycleStartTime,
                currentCycleEndTime:
                  fundingTest.fundingChallengeTest.currentCycleEndTime,
                currentProfit: fundingTest.fundingChallengeTest.currentProfit,
                currentSpending:
                  fundingTest.fundingChallengeTest.currentSpending,
                status: fundingTest.fundingChallengeTest.participantStatus,
                step: fundingTest.fundingChallengeTest.fundingChallengePhase
                  .order,
                market:
                  fundingTest.fundingChallengeTest.fundingChallengePhase
                    .fundingChallenge.fundingVendor.market.name,
                account: {
                  id: fundingTest.fundingChallengeTest.brokerAccount.id,
                  verified: fundingTest.fundingChallengeTest.verified,
                  identifier:
                    fundingTest.fundingChallengeTest.brokerAccount.identifier,
                  brokerName:
                    fundingTest.fundingChallengeTest.brokerAccount.broker.name,
                },
                evaluation: {
                  id: fundingTest.fundingChallengeTest.fundingChallengePhase.id,
                  initialBalance:
                    fundingTest.fundingChallengeTest.fundingChallengePhase
                      .initialBalance,
                  target:
                    fundingTest.fundingChallengeTest.fundingChallengePhase
                      .target,
                  periodInDays:
                    fundingTest.fundingChallengeTest.fundingChallengePhase
                      .periodInDays,
                  periodCost:
                    fundingTest.fundingChallengeTest.fundingChallengePhase
                      .fundingChallenge.periodCost,
                  vendorName:
                    fundingTest.fundingChallengeTest.fundingChallengePhase
                      .fundingChallenge.fundingVendor.name,
                  vendorMainWebsite:
                    fundingTest.fundingChallengeTest.fundingChallengePhase
                      .fundingChallenge.fundingVendor.mainWebsite,
                  vendorLogoUrl:
                    fundingTest.fundingChallengeTest.fundingChallengePhase
                      .fundingChallenge.fundingVendor.logoUrl,
                  vendorMainColor:
                    fundingTest.fundingChallengeTest.fundingChallengePhase
                      .fundingChallenge.fundingVendor.mainColor,
                  name: fundingTest.fundingChallengeTest.fundingChallengePhase
                    .fundingChallenge.fundingVendor.name,
                },
                ruleStatuses: response.data.map((rule) => {
                  return {
                    id: rule.fundingChallengeRule.id,
                    rule: rule.fundingChallengeRule.fundingRuleType,
                    referenceValue: rule.fundingChallengeRule.value,
                    currentValue: rule.currentValue,
                  };
                }),
              };
              this.market = newFundingTest.market;
              await this.setFundingTest(newFundingTest);
              var lang = navigator.language || navigator.userLanguage;
              this.$root.$i18n.locale = lang.split('-')[0];
              if (
                newFundingTest.status === "ABANDONED" ||
                newFundingTest.status === "WINNER" ||
                newFundingTest.status === "DISQUALIFIED" ||
                newFundingTest.status === "PAUSED"
              ) {
                this.$router.push({
                  name: "funding-simulation-feedback",
                  params: { fromPublic: true },
                });
              }
              await this.processPerformance();
            }
          }
        );
      } else {
        // Vista privada
        let testId =
          this.testId !== undefined
            ? this.testId
            : this.$store.state.fundingTest.id;
        Repository.fundingTestOverview(testId).then(async (response) => {
          if (response.status < 400) {
            this.overlayLoadingDetails = false;
            await this.setFundingTest(response.data);
            this.processPerformance();
          }
        });
      }
    },
    processPerformance() {
      this.calculateDays();
      this.processChartData();
    },
    calculateDays() {
      //let Difference_In_Time_Total = new Date(this.$store.state.fundingTest.nextPaymentTime).getTime() - new Date(this.$store.state.fundingTest.startTime).getTime();
      let Difference_In_Time_Total = Math.abs(
        new Date().getTime() -
        new Date(this.$store.state.fundingTest.createdAt).getTime()
      );
      this.totalDays = Math.floor(
        Difference_In_Time_Total / (1000 * 3600 * 24)
      );

      let Difference_In_Time_Remaining = Math.abs(
        new Date(this.$store.state.fundingTest.currentCycleEndTime).getTime() -
        new Date().getTime()
      );
      this.remainingDays = Math.floor(
        Difference_In_Time_Remaining / (1000 * 3600 * 24)
      );
      this.activeDays =
        this.$store.state.fundingTest.evaluation.periodInDays -
        this.remainingDays;

      this.cycles = Math.ceil(
        this.totalDays / this.$store.state.fundingTest.evaluation.periodInDays
      );
    },
    processChartData() {
      // Target
      let totalProfit = Math.abs(
        Number(this.$store.state.fundingTest.evaluation.initialBalance) -
        Number(this.$store.state.fundingTest.evaluation.target)
      );
      let reachedProfit =
        (Number(this.$store.state.fundingTest.currentProfit) / totalProfit) *
        100;
      this.stringDataBalance = {
        firstTitle: this.$t("target.targetTitle"),
        firstNumber:
          Number(this.$store.state.fundingTest.evaluation.target) -
          Number(this.$store.state.fundingTest.evaluation.initialBalance),
        secondTitle: this.$t("target.currentProfitTitle"),
        secondNumber: Number(this.$store.state.fundingTest.currentProfit),
        reachedProfit: reachedProfit.toFixed(1), // Agregar el porcentaje con dos decimales
      };
      this.seriesBalance = [reachedProfit];
      // Daily Loss
      let ruleStatusForDailyLoss =
        this.$store.state.fundingTest.ruleStatuses.find(
          (ruleStatus) => ruleStatus.rule === "MAX_DAILY_LOSS"
        );
      if (ruleStatusForDailyLoss !== undefined) {
        let reachedDailyLoss =
          (Math.abs(ruleStatusForDailyLoss.currentValue) /
            Math.abs(Number(ruleStatusForDailyLoss.referenceValue))) *
          100;
        this.stringDataDailyLoss = {
          firstTitle: this.$t("dailyLoss.dailyLossTitle"),
          firstNumber: Math.abs(Number(ruleStatusForDailyLoss.referenceValue)),
          secondTitle: this.$t("dailyLoss.todayLossTitle"),
          secondNumber: Math.abs(Number(ruleStatusForDailyLoss.currentValue)),
          reachedDailyLoss: reachedDailyLoss.toFixed(1),
        };
        this.seriesDailyLoss = [reachedDailyLoss];
      }
      // Drawdown Loss
      let ruleStatusForDrawdownLoss =
        this.$store.state.fundingTest.ruleStatuses.find(
          (ruleStatus) => ruleStatus.rule === "MAX_DRAWDOWN"
        );
      if (ruleStatusForDrawdownLoss !== undefined) {
        let reachedDrawdownLoss =
          (Math.abs(ruleStatusForDrawdownLoss.currentValue) /
            Math.abs(Number(ruleStatusForDrawdownLoss.referenceValue))) *
          100;
        this.stringDataDrawdownLoss = {
          firstTitle: this.$t("drawdownLoss.drawdownTitle"),
          firstNumber: Math.abs(
            Number(ruleStatusForDrawdownLoss.referenceValue)
          ),
          secondTitle: this.$t("drawdownLoss.currentTotalLossTitle"),
          secondNumber: Math.abs(
            Number(ruleStatusForDrawdownLoss.currentValue)
          ),
          reachedDrawdownLoss: reachedDrawdownLoss.toFixed(1),
        };
        this.seriesDrawdownLoss = [reachedDrawdownLoss];
      }
    },
    getShortDate(date) {
      return `${this.months[date.getMonth()]} ${date.getDate()}`;
    },
    getMonths() {
      this.months = [
        this.$t("months.jan"),
        this.$t("months.feb"),
        this.$t("months.mar"),
        this.$t("months.apr"),
        this.$t("months.may"),
        this.$t("months.jun"),
        this.$t("months.jul"),
        this.$t("months.aug"),
        this.$t("months.sep"),
        this.$t("months.oct"),
        this.$t("months.nov"),
        this.$t("months.dec"),
      ];
    },
    confirmAbandon() {
      this.overlayAbandon = true;
    },
    backToTest() {
      this.$router.push({ name: "funding-simulation-home" });
    },
    formatDate(date) {
      return `${this.getShortDate(date)} - ${date.getFullYear()} `;
    },
    formatNumber(number) {
      if (number >= 1000) {
        const formattedNumber = (number / 1000).toFixed(1);
        return formattedNumber.endsWith(".0")
          ? formattedNumber.slice(0, -2) + "K"
          : formattedNumber + "K";
      }
      return number;
    },
    scrollContainer(right) {
      let container = document.querySelector('.test-overview-card .cards-parent-container');

      if (window.innerWidth <= 768) {
        container.scrollBy(right ? 300 : -300, 0);
      } else {
        container.scrollBy(right ? 300 : -300, 0);
      }
    },
    updateSliderControlsStatus(container) {
      let a = container.scrollLeft;
      let b = container.scrollWidth - container.clientWidth;
      //Scroll percentage (0-1)
      let c = a / b;
      if (c == 0) {
        container.parentElement.querySelector(".prev-btn").setAttribute("disabled", "disabled");
        container.parentElement.querySelector(".next-btn").removeAttribute("disabled");
      }
      else if (c == 1) {
        container.parentElement.querySelector(".next-btn").setAttribute("disabled", "disabled");
        container.parentElement.querySelector(".prev-btn").removeAttribute("disabled");
      } else if (isNaN(c)) {
        container.parentElement.querySelector(".next-btn").setAttribute("disabled", "disabled");
        container.parentElement.querySelector(".prev-btn").setAttribute("disabled", "disabled");
      } else {
        container.parentElement.querySelector(".next-btn").removeAttribute("disabled", "disabled");
        container.parentElement.querySelector(".prev-btn").removeAttribute("disabled", "disabled");
      }
    },
    formatThousands(num, digits) {
      const lookup = [
        { value: 1, symbol: "" },
        { value: 1e3, symbol: "k" },
        { value: 1e6, symbol: "M" },
        { value: 1e9, symbol: "G" },
        { value: 1e12, symbol: "T" },
        { value: 1e15, symbol: "P" },
        { value: 1e18, symbol: "E" }
      ];
      const regexp = /\.0+$|(?<=\.[0-9]*[1-9])0+$/;
      const item = lookup.findLast(item => num >= item.value);
      return item ? (num / item.value).toFixed(digits).replace(regexp, "").concat(item.symbol) : "0";
    }

  },
};
</script>

<i18n>
{
  "en": {
    "title": "Your simulation on {market}",
    "cycleSubtitle": "Current Cycle",
    "start": "Start",
    "end": "End",
    "activityDays": "<b>Started at:</b> {from} ({days} days of evaluation)",
    "brokerAccount": "<b>Participating account:</b> {identifier} - {broker}",
    "payment": {
      "cyclesPrefix": "You have",
      "cyclesSuffix": "cycle | cycles",
      "amount": "Current Total",
      "simulationDisclaimer": "This is what you would have normally<br>paid in the current evaluation.<br>With <b style='color: #00F784'>Swiset</b> you can simulate unlimited times."
    },
    "target": {
      "targetTitle": "Target balance",
      "currentProfitTitle": "Current balance"
    },
    "dailyLoss": {
      "dailyLossTitle": "Max. Daily Loss",
      "todayLossTitle": "Current daily loss"
    },
    "drawdownLoss": {
      "drawdownTitle": "Max. Drawdown",
      "currentTotalLossTitle": "Current total loss"
    },
    "summary": {
      "title": "Summary",
      "market": {
        "Forex": "Forex evaluation ",
        "Futures": "Futures evaluation"
      }
    },
    "months": {
      "jan" : "Jan",
      "feb" : "Feb",
      "mar" : "Mar",
      "apr" : "Apr",
      "may" : "May",
      "jun" : "Jun",
      "jul" : "Jul",
      "aug" : "Aug",
      "sep" : "Sep",
      "oct" : "Oct",
      "nov" : "Nov",
      "dec" : "Dec"
    },
    "btnCreateAcc": "Create Account",
    "btnBackToTest": " Back to my simulations",
    "alreadyHasAcc": "If you already have a Swiset account",
    "login": "login"
  },
  "es": {
    "vendorPrefix": "Simulando una prueba de",
    "title": "Tú simulación en {market}",
    "cycleSubtitle": "Ciclo Actual",
    "start": "Inicio",
    "end": "Fin",
    "activityDays": "<b>Comenzado el:</b>  {from}({days} días de evaluación) | <b>Comenzado el:</b> {from} ({days} día de evaluación)",
    "brokerAccount": "<b>Participando con: </b>{identifier} - {broker}",
    "payment": {
      "cyclesPrefix": "Llevas",
      "cyclesSuffix": "ciclo | ciclos",
      "amount": "Total Actual",
      "simulationDisclaimer": "Esto es lo que hubieras pagado<br>normalmente en la prueba real.<br>Con <b style='color: #00F784'>Swiset</b> puedes simular ilimitadas veces."
    },
    "target": {
      "targetTitle": "Rendimiento Objetivo",
      "currentProfitTitle": "Rendimiento Actual"
    },
    "dailyLoss": {
      "dailyLossTitle": "Límite Diario de Pérdida",
      "todayLossTitle": "Pérdida Hoy"
    },
    "drawdownLoss": {
      "drawdownTitle": "Máximo Drawdown",
      "currentTotalLossTitle": "Drawdown"
    },
    "summary": {
      "title": "Resumen",
      "market": {
        "Forex": "Simulación en Forex",
        "Futures": "Simulación en Futuros"
      }
    },
    "months": {
      "jan" : "Ene",
      "feb" : "Feb",
      "mar" : "Mar",
      "apr" : "Abr",
      "may" : "May",
      "jun" : "Jun",
      "jul" : "Jul",
      "aug" : "Aug",
      "sep" : "Sep",
      "oct" : "Oct",
      "nov" : "Nov",
      "dec" : "Dec"
    },
    "btnCreateAcc": "Crear Cuenta",
    "btnBackToTest": " Volver a mis simulaciones",
    "alreadyHasAcc": "Si ya tienes una cuenta en Swiset",
    "login": "ingresa"
  }
}
</i18n>
<style lang="scss">
@import "src/global"; 

.theme--dark {
  .test-overview-card {
    .custom-img {
      background-color: #4E5966;
      border-top-right-radius: 10px;
    }
  }
}

.test-overview-card {
  @media (min-width: 769px) {
    margin-top: 10px;
  }

  @media (max-width: 768px) {
    padding: 50px 25px;
  }

  .header-controls {
    display: flex;
    justify-content: space-between;
    margin-bottom: 25px;
    align-items: center;

    @media (max-width: 768px) {
      max-width: unset;
    }

    p {
      color: #9A9A9A;
      font-family: "Avenir", sans-serif;

      @media (max-width: 768px) {
        font-size: 14px;
      }

      &:hover {
        cursor: pointer;
      }

      i {
        margin-right: 10px;
      }
    }
  }

  .logoContainer {
    align-items: center;

    .market-paragraph {
      color: #9A9A9A;
      font-size: 16px;
    }

    @media (max-width: 768px) {
      padding: 28px 17px;

      .market-paragraph {
        font-size: 14px;
        color: #9A9A9A;
      }
    }
  }

  .v-divider {
    border-color: #9A9A9A;
  }

  .rightInfo {
    align-items: center;

    @media (max-width: 768px) {
      width: 500px;

      h2 {
        font-size: 20px;
      }

      p {
        font-size: 16px;
      }
    }

  }

  .calendar-div {
    align-items: center;
    margin-bottom: 20px;

    p {
      margin: 0;
      margin-left: 10px;
      text-align: start;

      @media (max-width: 768px) {
        font-size: 14px;
      }
    }
  }

  .wallet-div {
    align-items: center;

    p {
      margin: 0;
      margin-left: 10px;
      text-align: start;

      @media (max-width: 768px) {
        font-size: 14px;
      }
    }
  }

  .cards-parent-container {

    margin-top: 40px;
    margin-bottom: 40px;
    width: 100%;

    @media (max-width: 768px) {
      -ms-overflow-style: none;
      scrollbar-width: none;
      scroll-behavior: smooth;
      overflow-x: scroll;
      margin-top: 0;
      margin-bottom: 20px;

      &::-webkit-scrollbar {
        display: none;
      }

    }

    .custom-row-card {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); // Adjust 200px as needed
      gap: 65px; // Adjust spacing between cards as needed

      @media (max-width: 768px) {
        overflow: auto;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        -ms-overflow-style: none;
        scrollbar-width: none;
        scroll-behavior: smooth;
        width: fit-content;
        gap: 0px;

        &::-webkit-scrollbar {
          display: none;
        }

        .card-custom {
          width: calc(60vw - 15px);
          margin-right: 15px;

          .v-card__text {
            padding: 0;

            .text-pair {
              p {
                font-size: 12px;
                text-align: start;
              }

              h2 {
                font-size: 20px;
              }
            }

            .v-progress-linear {
              margin-bottom: 0;
            }
          }
        }
      }

      .card-custom {
        border: 1px solid #9a9a9a;
        border-radius: 10px;

        .v-card__text {
          .text-pair {
            h2 {
              margin-left: auto;
            }
          }
        }
      }

    }

  }

  .slider-controls {
    display: none;
    flex-direction: row;
    width: 100%;
    justify-content: flex-end;
    margin-top: 20px;

    @media (max-width: 768px) {
      display: flex;
      margin-top: 10px;
    }

    button {
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      outline: 0;
      margin: 0px 10px;
      width: 10px;
      height: 10px;
      background: var(--v-mainGreen-base);
      padding: 15px;

      &.next-btn {
        margin-right: 0;
      }

      i {
        color: #000;
      }

      &:disabled {
        background: var(--v-mainBlack-base);
        opacity: 0.1;

        i {
          color: var(--v-mainWhite-base);
        }
      }
    }
  }

  .cardContainer {
    width: 80%;
    border: 1px solid #9A9A9A;
    border-radius: 10px;

    @media (min-width: 769px) {
      padding-left: 48px;
    }


    @media (max-width: 768px) {
      width: 100%;
      border-radius: 15px;
      text-align: center;
    }

    .col-cardContainer {
      @media (min-width: 769px) {
        padding-top: 36px;
      }
    }

    .cardContainer-container {
      @media (min-width: 769px) {
        padding-right: 48px;
        padding-bottom: 0;
      }
    }
  }

  .actions {
    margin-top: 40px;
    margin-bottom: 36px;

    @media (max-width: 768px) {
      margin: 0;
    }
  }

  .button-get-challenged {
    @media (max-width: 768px) {
      width: 100%;
      font-size: 14px;
    }

    .v-icon {
      margin-right: 10px;
      font-size: 14px;
    }

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background: var(--v-mainGreen-base);
    border: 1px solid transparent;
    outline: 0;
    border-radius: 10px;
    font-family: "Avenir",
    sans-serif;
    padding: 12px 20px;
    font-weight: bold;
  }

  .custom-h2 {
    text-align: right;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; // 36px
  }

  &.public-view {
    .actions {
      width: 100%;

      .buttons-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        @media (min-width: 769px) {
          .button-get-challenged {
            margin-left: auto;
          }

          .login-paragraph {
            text-align: end;
          }
        }

        @media (max-width: 768px) {
          flex-direction: column;
          margin-top: 20px;

          .create-account-container {
            width: 100%;
            margin-top: 30px;
            display: none;
          }

          .login-paragraph {
            font-size: 14px;
            margin-top: 5px;
            margin-bottom: 30px;
          }
        }
      }
    }
  }

  &.public-view {
    .rules-overview-outer {
      display: none;
    }
  }
}



.custom-img {
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 0;
  border-left: 1px solid var(--Grey-Medium, #9a9a9a);
  border-bottom: 1px solid #9A9A9A;

  @media (max-width: 768px) {
    border-left: none;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-bottom: 1px solid #9A9A9A;
    width: 100%; // Asegura que el borde cubra toda la anchura
    box-sizing: border-box; // Incluye el borde en el ancho total
  }
}

.responsive-col {
  @media (max-width: 769px) {
    width: 100%;
  }
}

.primary-color {
  color: $primary-color;
}

.white-content {
  color: $white-color;
}

.gray-content {
  color: #bdbdbd;
}

.card-custom {
  display: flex;
  padding: 15px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 10px;
  border: 1px solid #9a9a9a;
  box-shadow: none !important;
}

.text-pair {
  display: flex;
  align-items: center;

  p {
    margin-right: 10px;
  }
}

.responsive-div {
  max-width: 60%;
  max-height: 100%;

  @media (max-width: 700px) {
    max-width: 100%;
  }
}

.custom-progress {
  margin-top: 20px;
  border-radius: 10px;
  overflow: hidden;
}

.icon {
  width: 8px;
  height: 8px;
  margin-right: 8px;
}

.custom-paragraph {
  font-size: 14px;
}

.v-btn .custom-btn-class {
  background-color: transparent !important;
  color: var(--Grey-Medium, #9a9a9a);

  &:hover {
    background-color: transparent !important;
    color: var(--Grey-Medium, #9a9a9a);
  }
}

// Mobile
.responsive-row {
  display: flex;
  flex-direction: row;

  @media (max-width: 769px) {
    flex-direction: column-reverse;
  }
}

.second-col {
  order: 2;
}

//toltip
.custom-tooltip .v-tooltip__content {
  background-color: var(--Grey-Medium, #9a9a9a) !important;
}

// Estilos para los botones prev y next
.cardsButton {
  width: 27px;
  height: 27px;
  border-radius: 4px;
  margin-right: 10px; // Añade un margen derecho de 10px

  &:last-child {
    margin-right: 0; // Elimina el margen derecho del último botón
  }

  &.active {
    background-color: var(--v-mainGreen-base) !important;
  }

  &.inactive {
    background-color: #eeeeee !important;
  }
}

// estilos mobile
@media (max-width: 769px) {
  .mobile-only {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .mobile-only .v-col {
    width: 100%;
    justify-content: center;
  }
}

// Estilos para los iconos
.icon-active {
  color: black;
}

.icon-inactive {
  color: #9a9a9a;
}

.small-icon {
  font-size: 10px !important; // Ajusta el tamaño del icono aquí
}
</style>
<i18n>
{
  "en": {
    "title": "Your simulation on {market}",
    "cycleSubtitle": "Current Cycle",
    "start": "Start",
    "end": "End",
    "activityDays": "<b>Started at:</b> {from} ({days} days of evaluation)",
    "brokerAccount": "<b>Participating account:</b> {identifier} - {broker}",
    "payment": {
      "cyclesPrefix": "You have",
      "cyclesSuffix": "cycle | cycles",
      "amount": "Current Total",
      "simulationDisclaimer": "This is what you would have normally<br>paid in the current evaluation.<br>With <b style='color: #00F784'>Swiset</b> you can simulate unlimited times."
    },
    "target": {
      "targetTitle": "Target balance",
      "currentProfitTitle": "Current balance"
    },
    "dailyLoss": {
      "dailyLossTitle": "Max. Daily Loss",
      "todayLossTitle": "Current daily loss"
    },
    "drawdownLoss": {
      "drawdownTitle": "Max. Drawdown",
      "currentTotalLossTitle": "Current total loss"
    },
    "summary": {
      "title": "Summary",
      "market": {
        "Forex": "Forex evaluation ",
        "Futures": "Futures evaluation"
      }
    },
    "months": {
      "jan" : "Jan",
      "feb" : "Feb",
      "mar" : "Mar",
      "apr" : "Apr",
      "may" : "May",
      "jun" : "Jun",
      "jul" : "Jul",
      "aug" : "Aug",
      "sep" : "Sep",
      "oct" : "Oct",
      "nov" : "Nov",
      "dec" : "Dec"
    },
    "btnCreateAcc": "Create Account",
    "btnBackToTest": " Back to my simulations",
    "alreadyHasAcc": "If you already have a Swiset account",
    "login": "login"
  },
  "es": {
    "vendorPrefix": "Simulando una prueba de",
    "title": "Tú simulación en {market}",
    "cycleSubtitle": "Ciclo Actual",
    "start": "Inicio",
    "end": "Fin",
    "activityDays": "<b>Comenzado el:</b>  {from}({days} días de evaluación) | <b>Comenzado el:</b> {from} ({days} día de evaluación)",
    "brokerAccount": "<b>Participando con: </b>{identifier} - {broker}",
    "payment": {
      "cyclesPrefix": "Llevas",
      "cyclesSuffix": "ciclo | ciclos",
      "amount": "Total Actual",
      "simulationDisclaimer": "Esto es lo que hubieras pagado<br>normalmente en la prueba real.<br>Con <b style='color: #00F784'>Swiset</b> puedes simular ilimitadas veces."
    },
    "target": {
      "targetTitle": "Rendimiento Objetivo",
      "currentProfitTitle": "Rendimiento Actual"
    },
    "dailyLoss": {
      "dailyLossTitle": "Límite Diario de Pérdida",
      "todayLossTitle": "Pérdida Hoy"
    },
    "drawdownLoss": {
      "drawdownTitle": "Máximo Drawdown",
      "currentTotalLossTitle": "Drawdown"
    },
    "summary": {
      "title": "Resumen",
      "market": {
        "Forex": "Simulación en Forex",
        "Futures": "Simulación en Futuros"
      }
    },
    "months": {
      "jan" : "Ene",
      "feb" : "Feb",
      "mar" : "Mar",
      "apr" : "Abr",
      "may" : "May",
      "jun" : "Jun",
      "jul" : "Jul",
      "aug" : "Aug",
      "sep" : "Sep",
      "oct" : "Oct",
      "nov" : "Nov",
      "dec" : "Dec"
    },
    "btnCreateAcc": "Crear Cuenta",
    "btnBackToTest": " Volver a mis simulaciones",
    "alreadyHasAcc": "Si ya tienes una cuenta en Swiset",
    "login": "ingresa"
  },
  "ko": {
    "title": "{market} 시뮬레이션",
    "cycleSubtitle": "현재 사이클",
    "start": "시작",
    "end": "종료",
    "activityDays": "<b>시작일:</b> {from} ({days}일 평가)",
    "brokerAccount": "<b>참여 계정:</b> {identifier} - {broker}",
    "payment": {
      "cyclesPrefix": "보유 사이클:",
      "cyclesSuffix": "사이클",
      "amount": "현재 총액",
      "simulationDisclaimer": "이는 실제 평가에서<br>일반적으로 지불했을 금액입니다.<br><b style='color: #00F784'>Swiset</b>를 통해 무제한으로 시뮬레이션할 수 있습니다."
    },
    "target": {
      "targetTitle": "목표 잔액",
      "currentProfitTitle": "현재 잔액"
    },
    "dailyLoss": {
      "dailyLossTitle": "최대 일일 손실",
      "todayLossTitle": "현재 일일 손실"
    },
    "drawdownLoss": {
      "drawdownTitle": "최대 손실",
      "currentTotalLossTitle": "현재 총 손실"
    },
    "summary": {
      "title": "요약",
      "market": {
        "Forex": "외환 평가",
        "Futures": "선물 평가"
      }
    },
    "months": {
      "jan": "1월",
      "feb": "2월",
      "mar": "3월",
      "apr": "4월",
      "may": "5월",
      "jun": "6월",
      "jul": "7월",
      "aug": "8월",
      "sep": "9월",
      "oct": "10월",
      "nov": "11월",
      "dec": "12월"
    },
    "btnCreateAcc": "계정 생성",
    "btnBackToTest": "내 시뮬레이션으로 돌아가기",
    "alreadyHasAcc": "이미 Swiset 계정이 있으신가요?",
    "login": "로그인"
  },
  "pt": {
    "title": "Sua simulação em {market}",
    "cycleSubtitle": "Ciclo Atual",
    "start": "Início",
    "end": "Fim",
    "activityDays": "<b>Iniciado em:</b> {from} ({days} dias de avaliação)",
    "brokerAccount": "<b>Conta participante:</b> {identifier} - {broker}",
    "payment": {
      "cyclesPrefix": "Você tem",
      "cyclesSuffix": "ciclo | ciclos",
      "amount": "Total Atual",
      "simulationDisclaimer": "Este é o valor que você normalmente<br>pagaria na avaliação atual.<br>Com o <b style='color: #00F784'>Swiset</b>, você pode simular quantas vezes quiser."
    },
    "target": {
      "targetTitle": "Saldo alvo",
      "currentProfitTitle": "Saldo atual"
    },
    "dailyLoss": {
      "dailyLossTitle": "Perda diária máxima",
      "todayLossTitle": "Perda diária atual"
    },
    "drawdownLoss": {
      "drawdownTitle": "Redução máxima",
      "currentTotalLossTitle": "Perda total atual"
    },
    "summary": {
      "title": "Resumo",
      "market": {
        "Forex": "Avaliação de Forex",
        "Futures": "Avaliação de Futuros"
      }
    },
    "months": {
      "jan": "Jan",
      "feb": "Fev",
      "mar": "Mar",
      "apr": "Abr",
      "may": "Mai",
      "jun": "Jun",
      "jul": "Jul",
      "aug": "Ago",
      "sep": "Set",
      "oct": "Out",
      "nov": "Nov",
      "dec": "Dez"
    },
    "btnCreateAcc": "Criar Conta",
    "btnBackToTest": "Voltar às minhas simulações",
    "alreadyHasAcc": "Se você já tem uma conta Swiset",
    "login": "entrar"
  },
  "th": {
    "title": "การจำลองของคุณใน {market}",
    "cycleSubtitle": "รอบปัจจุบัน",
    "start": "เริ่มต้น",
    "end": "สิ้นสุด",
    "activityDays": "<b>เริ่มต้นเมื่อ:</b> {from} ({days} วันของการประเมิน)",
    "brokerAccount": "<b>บัญชีที่เข้าร่วม:</b> {identifier} - {broker}",
    "payment": {
      "cyclesPrefix": "คุณมี",
      "cyclesSuffix": "รอบ",
      "amount": "ยอดรวมปัจจุบัน",
      "simulationDisclaimer": "นี่คือสิ่งที่คุณจะต้องจ่าย<br>ในการประเมินปัจจุบันตามปกติ<br>ด้วย <b style='color: #00F784'>Swiset</b> คุณสามารถจำลองได้ไม่จำกัดครั้ง"
    },
    "target": {
      "targetTitle": "ยอดเงินเป้าหมาย",
      "currentProfitTitle": "ยอดเงินปัจจุบัน"
    },
    "dailyLoss": {
      "dailyLossTitle": "การขาดทุนรายวันสูงสุด",
      "todayLossTitle": "การขาดทุนรายวันปัจจุบัน"
    },
    "drawdownLoss": {
      "drawdownTitle": "การลดลงสูงสุด",
      "currentTotalLossTitle": "การขาดทุนรวมปัจจุบัน"
    },
    "summary": {
      "title": "สรุป",
      "market": {
        "Forex": "การประเมิน Forex",
        "Futures": "การประเมิน Futures"
      }
    },
    "months": {
      "jan": "ม.ค.",
      "feb": "ก.พ.",
      "mar": "มี.ค.",
      "apr": "เม.ย.",
      "may": "พ.ค.",
      "jun": "มิ.ย.",
      "jul": "ก.ค.",
      "aug": "ส.ค.",
      "sep": "ก.ย.",
      "oct": "ต.ค.",
      "nov": "พ.ย.",
      "dec": "ธ.ค."
    },
    "btnCreateAcc": "สร้างบัญชี",
    "btnBackToTest": "กลับไปที่การจำลองของฉัน",
    "alreadyHasAcc": "หากคุณมีบัญชี Swiset อยู่แล้ว",
    "login": "เข้าสู่ระบบ"
  },
  "vi": {
    "title": "Mô phỏng của bạn trên {market}",
    "cycleSubtitle": "Chu kỳ hiện tại",
    "start": "Bắt đầu",
    "end": "Kết thúc",
    "activityDays": "<b>Bắt đầu vào:</b> {from} ({days} ngày đánh giá)",
    "brokerAccount": "<b>Tài khoản tham gia:</b> {identifier} - {broker}",
    "payment": {
      "cyclesPrefix": "Bạn có",
      "cyclesSuffix": "chu kỳ",
      "amount": "Tổng hiện tại",
      "simulationDisclaimer": "Đây là số tiền bạn thường phải trả<br>trong đánh giá hiện tại.<br>Với <b style='color: #00F784'>Swiset</b>, bạn có thể mô phỏng không giới hạn."
    },
    "target": {
      "targetTitle": "Số dư mục tiêu",
      "currentProfitTitle": "Số dư hiện tại"
    },
    "dailyLoss": {
      "dailyLossTitle": "Lỗ hàng ngày tối đa",
      "todayLossTitle": "Lỗ hàng ngày hiện tại"
    },
    "drawdownLoss": {
      "drawdownTitle": "Sụt giảm tối đa",
      "currentTotalLossTitle": "Tổng lỗ hiện tại"
    },
    "summary": {
      "title": "Tóm tắt",
      "market": {
        "Forex": "Đánh giá Forex",
        "Futures": "Đánh giá Hợp đồng tương lai"
      }
    },
    "months": {
      "jan": "Thg 1",
      "feb": "Thg 2",
      "mar": "Thg 3",
      "apr": "Thg 4",
      "may": "Thg 5",
      "jun": "Thg 6",
      "jul": "Thg 7",
      "aug": "Thg 8",
      "sep": "Thg 9",
      "oct": "Thg 10",
      "nov": "Thg 11",
      "dec": "Thg 12"
    },
    "btnCreateAcc": "Tạo tài khoản",
    "btnBackToTest": "Quay lại mô phỏng của tôi",
    "alreadyHasAcc": "Nếu bạn đã có tài khoản Swiset",
    "login": "đăng nhập"
  },
  "zh": {
    "title": "您在 {market} 的模拟",
    "cycleSubtitle": "当前周期",
    "start": "开始",
    "end": "结束",
    "activityDays": "<b>开始于：</b>{from}（评估天数：{days} 天）",
    "brokerAccount": "<b>参与账户：</b>{identifier} - {broker}",
    "payment": {
      "cyclesPrefix": "您拥有",
      "cyclesSuffix": "个周期",
      "amount": "当前总额",
      "simulationDisclaimer": "这是您在当前评估中通常需要支付的金额。<br>使用 <b style='color: #00F784'>Swiset</b>，您可以无限次进行模拟。"
    },
    "target": {
      "targetTitle": "目标余额",
      "currentProfitTitle": "当前余额"
    },
    "dailyLoss": {
      "dailyLossTitle": "每日最大亏损",
      "todayLossTitle": "当前每日亏损"
    },
    "drawdownLoss": {
      "drawdownTitle": "最大回撤",
      "currentTotalLossTitle": "当前总亏损"
    },
    "summary": {
      "title": "摘要",
      "market": {
        "Forex": "外汇评估",
        "Futures": "期货评估"
      }
    },
    "months": {
      "jan": "一月",
      "feb": "二月",
      "mar": "三月",
      "apr": "四月",
      "may": "五月",
      "jun": "六月",
      "jul": "七月",
      "aug": "八月",
      "sep": "九月",
      "oct": "十月",
      "nov": "十一月",
      "dec": "十二月"
    },
    "btnCreateAcc": "创建账户",
    "btnBackToTest": "返回我的模拟",
    "alreadyHasAcc": "已经拥有 Swiset 账户？",
    "login": "登录"
  }
}
</i18n>